import React, { useEffect, useState } from "react";

import { ChartData, ChartOptions, ChartType } from "chart.js";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Spin } from "antd";

import { ChartItem } from "../../../../store/feedbacks/types";
import { RootState } from "../../../../store/root_reducer";

import { handleData, handleOptions } from "./settings";

export type FeedbacksChartType = "ratings" | "csi";

export interface FeedbacksChartProps {
  type: FeedbacksChartType;
}

export const FeedbacksChart: React.FC<FeedbacksChartProps> = (props) => {
  const { t } = useTranslation("feedbacks_page");
  const [options, setOptions] = useState<ChartOptions<"line">>({});
  const [data, setData] = useState<ChartData<"line", ChartItem[]>>({ datasets: [] });

  const feedbacksState = useSelector((state: RootState) => state.Feedbacks);

  useEffect(() => {
    if (!feedbacksState.chartDataIsLoading) {
      setData(handleData(t, feedbacksState.chartItems, props.type));
      setOptions(handleOptions(t, props.type));
    }
  }, [t, props.type, feedbacksState.chartItems, feedbacksState.chartDataIsLoading]);

  return (
    <Spin spinning={feedbacksState.chartDataIsLoading}>
      <Line data={data} options={options} height={75} type={"line" as ChartType} />
    </Spin>
  );
};
